import { Dialog } from '@eta/components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './ErrorNotFondPermession.scss';

export interface ErrorNotFondPermessionProps {
    hidden: boolean;
    onClose: () => void;
}


export const ErrorNotFondPermession: FC<ErrorNotFondPermessionProps> = (props: ErrorNotFondPermessionProps ) => {
    const {hidden,onClose} = props;
    const { t } = useTranslation(['intermediaries', 'common']);
    return (
        <Dialog
            containerClassName='InValidPermessions'
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={750}
            title={t('InValidPermession')}
        >
            <div className="intermediary">
                <div className='content'>
                
                    <div className="bodyLine">
                        {t('InvalidPermessionMsg')}
                    </div>
                    
                    
                </div>
            </div>
        </Dialog>
    );
};
